/**
 * Author : zhengyanfeng.
 * Date   : 2021/1/5.
 * File   : province. 省份id对象
 */
export default {
  '350000': {
    position: {
      left: '1215px',
        top: '585px'
    },
    collectPosition: {
      left: '47px',
      top: '39px'
    },
    background: require('../../mapPoint/mapPicture/fujian/index.png')
  },
  '330000': {
    position: {
      left: '1238px',
      top: '526px'
    },
    collectPosition: {
      left: '55px',
      top: '20px'
    },
    background: require('../../mapPoint/mapPicture/zhejiang/index.png')
  },
  //原先是130000，因为辅布司原因修改成130001，不展示
  '130001': {
    position: {
      left: '1250px',
      top: '258px'
    },
    collectPosition: {
      left: '70px',
      top: '10px'
    },
    background: require('../../mapPoint/mapPicture/jilin/index.png')
  },
  '650000': {
    position: {
      left: '825px',
      top: '588px'
    },
    collectPosition: {
      left: '120px',
      top: '60px'
    },
    background: require('../../mapPoint/mapPicture/yunnan/index.png')
  }
}



//////////////////
// WEBPACK FOOTER
// ./static/mapPoint/cityPoint/province.js
// module id = rfaB
// module chunks = 6